import { packGroups, packs } from '@/mocks/homeData';
import SectionHead from './SectionHead';

export default function Packs() {
  return (
    <section id="packs" className="bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
        <SectionHead
          anchorId="packs"
          kicker="Archive · 打包资源"
          title="网盘五一黑料打包下载"
          desc="省去东翻西找的麻烦，本站按题材手动封装，图文版 / 视频版 / 动图弹幕任你挑选。"
          href="#packs"
          accent="primary"
        />

        {/* 资源形态速览 */}
        <div className="mb-6 grid grid-cols-2 lg:grid-cols-4 gap-3">
          {packGroups.map((g, i) => (
            <a
              key={i}
              href="#packs"
              className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3.5 transition-colors hover:border-primary-300"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-50 text-primary-600">
                <i className={['ri-image-2-line', 'ri-vidicon-line', 'ri-bubble-chart-line', 'ri-file-text-line'][i]}></i>
              </span>
              <div className="min-w-0">
                <h3 className="text-sm font-bold text-foreground-950">{g.name}</h3>
                <p className="truncate text-xs text-foreground-500">{g.desc}</p>
              </div>
              <span className="ml-auto whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-xs font-semibold text-secondary-900">
                {g.count} 份
              </span>
            </a>
          ))}
        </div>

        {/* 打包卡片流 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {packs.map((p, i) => (
            <a
              key={i}
              href="#packs"
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-background-300"
            >
              <div className="relative h-44 overflow-hidden bg-background-100">
                <img
                  src={p.img}
                  alt={p.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-foreground-950/10 to-transparent"></div>
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-bold text-background-50">
                  <i className="ri-download-cloud-2-line"></i> {p.badge}
                </span>
                <span className="absolute bottom-3 right-3 inline-flex items-center gap-1 rounded bg-foreground-950/75 px-2 py-1 text-[11px] text-background-100">
                  <i className="ri-file-zip-line"></i> {p.size}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="line-clamp-1 font-heading text-[15px] font-bold text-foreground-950 group-hover:text-primary-600">
                  {p.title}
                </h3>
                <p className="mt-1.5 line-clamp-2 flex-1 text-[13px] leading-relaxed text-foreground-500">{p.note}</p>
                <div className="mt-4 flex items-center justify-between gap-2 border-t border-background-200/80 pt-3">
                  <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-user-follow-line text-primary-500"></i> 已收录 {p.count} 组
                  </span>
                  <span className="inline-flex whitespace-nowrap items-center gap-1 rounded-md bg-primary-500 px-3 py-1.5 text-xs font-semibold text-background-50 transition-colors group-hover:bg-primary-600">
                    <i className="ri-download-2-line"></i> 获取资源
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}